import * as types from './actionTypes';

export const get = ()=>{
    return{
      type: types.PROVINCE_REQUEST
    }
};

export const getSuccess= data => {
    return {
        type: types.PROVINCE_SUCCESS,
        payLoad: data
    };
};
export const getFailure= () => {
    return {
        type: types.PROVINCE_FAILURE
    };
};

export const getCity =(data)=>{
    return{
      type: types.CITY_REQUEST,
      data: data
    }
};

export const getCitySuccess= data => {
    return {
        type: types.CITY_SUCCESS,
        payLoad: data
    };
};
export const getCityFailure= () => {
    return {
        type: types.CITY_FAILURE
    };
};

export const cleanCities=()=>{
    return{
        type: types.CITY_CLEAN_LIST
    }
};